import Vue from "vue";
import Form from "../../../../classes/Form";
import {route} from "../../../../functions/route";
import {httpClient} from "../../../../httpClients/httpClient";
import crud from "../../../../stores/crud";

const getDefaultState = () => {
	return {
		...crud.state,
		sendRegistrationEmailForm: new Form({}, httpClient),
		sendLoginEmailForm: new Form({}, httpClient),
		sendIdEmailForm: new Form({}, httpClient),
		sendQuoteForm: new Form({}, httpClient),
		routes: {
			index: "clients",
			show: "clients/:client",
			sendRegistrationEmail: "clients/:client/send-portal-registration-email",
			sendLoginEmail: "clients/:client/send-portal-login-email",
			sendIdEmail: "clients/:client/send-id-check-email",
			sendLeadQuoteEmail: "leads/:lead/resend-email/:client",
			sendInstructionQuoteEmail: "instructions/:instruction/resend-email/:client",
		},
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
		updateOutstandingInvoice({commit}, payload) {
			commit("UPDATE_OUTSTANDING_INVOICE", payload);
		},
		sendRegistrationEmail({state}) {
			return state.sendRegistrationEmailForm.delayResponse(1000).post(route(state.routes.sendRegistrationEmail, state.activeItem));
		},
		sendLoginEmail({state}) {
			return state.sendLoginEmailForm.delayResponse(1000).post(route(state.routes.sendLoginEmail, state.activeItem));
		},
		sendIdEmail({state}) {
			return state.sendIdEmailForm.delayResponse(1000).post(route(state.routes.sendIdEmail, state.activeItem));
		},
		sendQuoteEmail({state}, {lead, instruction}) {
			let uri = lead ?
				route(state.routes.sendLeadQuoteEmail, [lead, state.activeItem]) :
				route(state.routes.sendInstructionQuoteEmail, [instruction, state.activeItem]);
			return state.sendQuoteForm.delayResponse(1000).post(uri);
		},
	},
	mutations: {
		...crud.mutations,
		ADD_SERVICES(state, payload) {
			_.each(payload, (service, index) => {
				state.activeItem.instructions.push(service);
			});
		},
		UPDATE_OUTSTANDING_INVOICE(state, payload) {
			let indexItem = state.items.find(item => payload.invoice_payer_id);

			if (indexItem) {
				Vue.set(indexItem, "outstandingInvoice", payload);
			}

			if (state.activeItem.id === payload.invoice_payer_id) {
				Vue.set(state.activeItem, "outstandingInvoice", payload);
			}
		},
		PUSH_TODO(state, payload) {
			let todo = payload.todo;
			let clientId = todo.client.id;
			let indexItem = state.items.find(item => item.group.id === clientId);

			if (indexItem) {
				indexItem.group.todos.push(todo);
			}

			if (state.activeItem.id === clientId) {
				state.activeItem.group.todos.push(todo);
			}
		},
		PUSH_APPOINTMENT(state, {appointment, client, leadId}) {
			let clientId = client.id;
			let indexItem = state.items.find(item => item.id === clientId);

			if (indexItem) {
				indexItem.group.appointments.push(appointment);
			}

			if (state.activeItem.id === clientId) {
				state.activeItem.group.appointments.push(appointment);

				if (leadId) {
					let lead = state.activeItem.leads.find(lead => lead.id === leadId);

					lead.appointments.push(appointment);
					Vue.set(lead.requirements.appointment, "complete", true);
					Vue.set(lead.actions, "appointForRecipient", false);
				}
			}
		},
		ADD_LEAD(state, payload) {
			let indexItem = state.items.find(item => item.id === payload.clientId);

			if (indexItem) {
				indexItem.leads.push(payload.lead);
			}

			if (!indexItem && state.activeItem.id === payload.clientId) {
				state.activeItem.leads.push(payload.lead);
			}
		},
		LEAD_UPDATED(state, payload) {
			let leadIndex = state.activeItem?.leads?.findIndex(i => i.id === payload.id);

			Vue.set(
				state.activeItem.leads,
				leadIndex,
				Object.assign({}, state.activeItem.leads[leadIndex], payload),
			);
		},
		ADD_INSTRUCTIONS(state, payload) {
			let instructions = payload.instructions;

			_.each(instructions, instruction => {
				if (state.activeItem.group.id !== instruction.clientGroup.id) {
					return;
				}

				let activeItem = state.activeItem;

				activeItem.group.instructions.push(instruction);
				activeItem.group.leads = _.filter(activeItem.group.leads, function (lead) {
					return lead.id !== payload.lead.id;
				});

				state.activeItem = {...activeItem};
			});
		},
		INSTRUCTION_UPDATED(state, payload) {
			let instructionIndex = null;
			let instruction = _.find(state.activeItem.instructions, (instruction, index) => {
				instructionIndex = index;
				return instruction.id === payload.id;
			});
			if (!instruction) {
				return;
			}
			// console.log(instructionIndex, instruction);
			// return;
			// let instructionIndex = state.activeItem.instructions.findIndex(i => i.id === payload.id);
			// console.log(instructionIndex);
			// let instruction = state.activeItem.instructions[instructionIndex];
			// console.log(instruction);
			// let replacement = Object.assign({}, instruction, payload);
			// console.log(replacement);
			Vue.set(state.activeItem.instructions, instructionIndex, Object.assign({}, instruction, payload));
		},
		ADD_COMPARISON_INSTRUCTION(state, payload) {
			if (payload.comparison?.id === state.activeItem.comparison?.id) {
				let serviceProvider = _.find(state.activeItem.comparison.serviceProviders, function (serviceProvider) {
					return serviceProvider.id === payload.service_provider_id;
				});
				Vue.set(state.activeItem.comparison, "active_instruction", payload);
				Vue.set(serviceProvider.pivot, "instruction", payload);
			}
		},
		UPDATE_RELATED_CLIENTS(state, payload) {
			let indexItem = state.items.find(item => item.id === payload.client.id);

			if (indexItem) {
				indexItem.relatedClients = payload.relatedClients;
			}

			if (!indexItem && state.activeItem.id === payload.client.id) {
				state.activeItem.relatedClients = payload.relatedClients;
			}
		},
		REMOVE_ID_CHECK(state, payload) {
			let idChecks = _.remove(state.activeItem.group.idChecks, ["id", payload]);
			Vue.set(state.activeItem.group, "idChecks", idChecks);
			if (state.activeItem.idCheck?.id === payload) {
				Vue.set(state.activeItem, "idCheck", null);
			}
		},
		setSearchPack(state, searchPack) {
			Vue.set(state.activeItem, "searchPack", searchPack);
			Vue.set(state.activeItem.group.addresses, searchPack.address.type, searchPack.address);
		},
		updateIdCheck(state, idCheck) {
			// let oldIdCheckIndex = _.drop(state.activeItem.group.idChecks, ["id", idCheck.id]);
			// Vue.set(state.activeItem.group.idChecks, oldIdCheckIndex, idCheck);

			if (state.activeItem.idCheck?.id !== idCheck.id) {
				return;
			}

			Vue.set(state.activeItem, "idCheck", idCheck);
		},
	},
	getters: {
		...crud.getters,
	},
};
